export function playlistEditorPath({ playlistId }: { playlistId: string }) {
    return `/editor/playlist/${playlistId}/edit`;
}
